// extracted by mini-css-extract-plugin
export default {"titleBox":"SalesLayout_titleBox__OjzR0","icon":"SalesLayout_icon__HPyL6","redStar":"SalesLayout_redStar__nwMAH","h1":"SalesLayout_h1__VFFU2"};